import type { IconButtonProps } from '@mui/material/IconButton';

import { useState } from 'react';
import { usePopover } from 'minimal-shared/hooks';

import { Box, Button } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';

import { useTranslate } from 'src/locales';

import { Scrollbar } from 'src/components/scrollbar';
import { CustomPopover } from 'src/components/custom-popover';

// ----------------------------------------------------------------------

export type ContactsPopoverProps = IconButtonProps & {
  data?: {
    id: string;
    name: string;
    value: string;
  }[];
};

export function BuyNowButton({ data = [], sx, ...other }: ContactsPopoverProps) {
  const { open, anchorEl, onClose, onOpen } = usePopover();

  const { t } = useTranslate('translation');

  const [selectedContactId, setSelectedContactId] = useState<string[] | null>(null);

  const handleSelectContact = (id: string) => {
    setSelectedContactId((prev) => {
      if (prev === null) {
        return [id];
      }
      if (prev.includes(id)) {
        return prev.filter((contactId) => contactId !== id);
      }
      return [...prev, id];
    });
  };

  const renderMenuList = () => (
    <CustomPopover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      slotProps={{ arrow: { offset: 20 } }}
    >
      <Scrollbar sx={{ height: 180, width: 280 }}>
        {data.map((contact) => (
          <MenuItem
            key={contact.id}
            sx={{
              p: 1,
              bgcolor: selectedContactId?.includes(contact.id) ? 'action.selected' : 'inherit',
            }}
            onClick={() => handleSelectContact(contact.id)}
          >
            <ListItemText
              primary={contact.name}
              slotProps={{
                secondary: {
                  sx: { typography: 'caption', color: 'text.disabled' },
                },
              }}
            />
          </MenuItem>
        ))}
      </Scrollbar>
    </CustomPopover>
  );

  return (
    <Box sx={{ mx: 2 }}>
      <Button
        aria-label="Buy now button"
        // onClick={onOpen}
        variant="contained"
        sx={[
          (theme) => ({ ...(open && { bgcolor: theme.palette.action.selected }) }),
          ...(Array.isArray(sx) ? sx : [sx]),
          { width: '100%' },
        ]}
      >
        {/* <Tooltip title={t('BUY_NOW')} placement="bottom" arrow> */}
        {t('BUY_NOW')}
        {/* </Tooltip> */}
      </Button>

      {renderMenuList()}
    </Box>
  );
}
